import defaultContent from "../default";
import { iconsSet as icons } from "../../../../assets/icons/icons";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_quantifique.png",
      alt: "Estratégias Quantifique",
    },
    title:
      "Invista no Mercado Financeiro utilizando o poder da inteligência artificial.",

    // String ou array de strings
    text: "Idealizada por Luiz Barichello e Rodrigo Cohen, a Quantifique é uma plataforma digital de recomendações e sinais para investimentos na Bolsa de Valores. Com essa extensão você consegue utilizar as estratégias da Quantifique de forma 100% automatizada!",
    testimonial: {
      text: "Utilizando indicadores e padrões gráficos, construímos uma poderosa inteligência artifical capaz de se adaptar ao mercado.",
      author: {
        name: "Luiz Barichello, Quant Reseacher",
        picture: "",
      },
    },
  },
  stats: {
    title: "Alguns números da Quantifique",
    subtitle:
      "Nascemos para simplificar a vida do investidor e trazer tranquilidade e clareza em cada operação.",
    data: [
      {
        value: "+15",
        description: "Anos de experiência na bolsa",
      },
      {
        value: "+2",
        description: "Anos de geração de sinais",
      },
      {
        value: "+1.5k",
        description: "Clientes atendidos",
      },
    ],
  },
  features: {
    title: "Por que assinar a Quantifique agora mesmo?",
    subtitle: "Veja quais as principais vantagens das estratégias Quantifique.",
    data: [
      {
        icon: icons.click,
        title: "Simples e objetiva",
        description:
          "Você não precisa ser um expert na Bolsa de Valores e muito menos especialista em tecnologia para utilizar os nossos robôs.",
      },
      {
        icon: icons.arrow_right_sm,
        title: "Sempre um passo a frente",
        description:
          "Nossa inteligência artificial monitora todas as estratégias. Antes que uma delas diminua a performance, nós a atualizamos. Se o mercado muda, nós mudamos.",
      },
      {
        icon: icons.group,
        title: "Para todo mundo",
        description:
          "Independente da sua preferência, você encontrará estratégias inteligentes que se adequem ao seu operacional.",
      },
      ...defaultContent.features.data,
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Quantifique.",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Quantifique",
    col1: [
      "Nascemos para simplificar a vida do investidor e trazer tranquilidade e clareza em cada operação.",
      "Somos certificados pela APIMEC (Associação dos Analistas e Profissionais de Investimento do Mercado de Capitais).",
    ],
    col2: [
      "Isso traz toda segurança e garantia para você sobre de que nossas estratégias são feitas com muita seriedade por profissionais qualificados e em total conformidade com as leis brasileiras.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle:
      "Conheça os planos da Quantifique e veja qual se adequa melhor ao seu perfil.",
  },
  strategies: {
    title: "Estratégias Quantifique",
    heading: "Estratégias quantitativas validadas",
    subtitle:
      "Conheça as estratégias da Quantifique disponíveis na plataforma.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
